<template>
  <div class="flowCenter">
    <div class="box">
      <div class="container clear">
        <div class="main-left fl">
            <sidebar-page></sidebar-page>
        </div>
        <div class="main-right fl">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane class="flow tab" label="   流量任务   " name="tbTask">
              <el-form  label-width="84px"   label-position="right">
                <el-form-item label="任务类型">
                  <div class="commonTabnav">
                    <ul>
                      <li :class="type == item.type?'active':''" v-for="(item, index) in tabnav1" :key="index" @click="tabChange(item.type, item.link)">{{item.name}}</li>
                    </ul>
                  </div>
                </el-form-item>
              </el-form>
              <el-form label-width="84px" :model="formList" label-position="right">
                  <el-form-item label="宝贝链接" prop="link">
                      <el-input v-model="formList.goodsUrl" placeholder="请输入宝贝链接" @input="changeLink" clearable></el-input>
                      <!-- <el-autocomplete
                        class="el-input"
                        v-model="formList.goodsUrl"
                        :fetch-suggestions="querySearch"
                        placeholder="请输入内容"
                        clearable
                         @input="changeLink"
                      ></el-autocomplete> -->
                  </el-form-item>
                  <el-form-item label="宝贝标题" prop="link">
                      <el-input class="input-with-select" placeholder="标题自动获取或手动填写" v-model="formList.goodsTitle"></el-input>
                      <div class="taotask_time taotask-item" v-for="(item,keys) in keyForm" :key="keys">
                          <span class="taotaskAdd" @click="addkey(keys)">+</span ><span class="taotaskReduce" @click="delkey">-</span>
                          <el-form-item :label="'关键词'+(keys+1)">
                              <el-input  class="input-with-select" v-model="item.keyword" @input="getKey(item.keyword, keys)" placeholder="关键词必须为标题内含有文字，且区分大小写"></el-input>
                          </el-form-item>
                          <el-row>
                              <el-col :span="4">
                                <p class="txt-right">APP流量</p>
                              </el-col>
                              <el-col :span="10">
                                  <el-form-item label="访客数">
                                      <input class="likeInput" type="number" name="" v-model="item.visitNum" @input="changePer(item.visitNum,keys,0)">
                                  </el-form-item>
                              </el-col>
                              <el-col :span="10">
                                  <el-form-item label="展现量">
                                      <input class="likeInput" type="number" name="" v-model="item.showNum" @input="changeShow(item.showNum,item.showNum1,item.showNum2,keys)">
                                  </el-form-item>
                              </el-col>
                          </el-row>
                          <div class="taoQs">
                              <div class="taoQs_box">
                                  <div class="taoQs_boxText">
                                      <h5>如何控制访客？</h5>
                                      <p>如何提高关键词排名、提高宝贝人气、提高宝贝权重 :
                                          合理控制宝贝的展现和访客的比例，(多发展现，控制访客)
                                          例如宝贝展现100人次，宝贝平均访客应在2-5人左右
                                          控制任务投放时段和任务间隔，避免较多流量同时进入店铺
                                          利用宝贝展现来控制点击率，让销售和流量更加真实安全
                                      </p>
                                  </div>
                                  <span class="taoQs_span" >如何控制访客？</span>
                              </div>
                              <div class="taoQs_box">
                                  <div class="taoQs_boxText">
                                      <h5>什么是展现量？</h5>
                                      <p>展现量就是宝贝展现在买家面前的次数。（就是宝贝所在页面被打开的次数）
                                          比如搜索某个关键词，宝贝展示在第二页 :
                                          那么当一个买家搜索这个关键词，并翻到了第二页，就算这个词一次展现量。 如果买家搜索了这个关键词，然后直接点击跳到了第五页，是不算这个词的展现量。
                                      </p>
                                  </div>
                                  <span class="taoQs_span">什么是展现量？</span>
                              </div>

                          </div>
                          <div class="tasktimeBox_fa">
                              <p class="tit">单日时间细分</p>
                              <div class="tasktimeBox_fa_dis">
                                <div class="tasktimeBox" v-for="i in 24" :key="i">
                                    <p class="bg">{{i-1}}</p>
                                    <!-- <input type="number" name="" min="0" v-model="item.timeSlot[i-1]" :disabled="i<=(timeNum+1)" @change="changeTime(keys,item.timeSlot[i-1],(i-1),0)"> -->
                                    <input type="number" name="" min="0" v-model="item.timeSlot[i-1]" @change="changeTime(keys,item.timeSlot[i-1],(i-1),0)">
                                </div>
                              </div>

                          </div>
                          <hr>
                          <el-row>
                              <el-col :span="4">
                                <p class="txt-right">搜索收藏</p>
                              </el-col>
                              <el-col :span="10">
                                  <el-form-item label="访客数">
                                      <input class="likeInput" type="number" name="" v-model="item.visitNum1" @input="changePer(item.visitNum1,keys,1)" >
                                  </el-form-item>
                              </el-col>
                              <!-- <el-col :span="10">
                                  <el-form-item label="展现量">
                                      <input  class="likeInput" type="number" name=""  v-model="item.showNum1"  @input="changeShow(item.showNum,keys)">
                                  </el-form-item>
                              </el-col> -->
                          </el-row>
                          <div class="tasktimeBox_fa">
                              <p class="tit">单日时间细分</p>
                              <div class="tasktimeBox_fa_dis">
                                <div class="tasktimeBox" v-for="i in 24" :key="i">
                                    <p class="bg">{{i-1}}</p>
                                    <input type="number" name="" min="0" v-model="item.timeSlot1[i-1]" @change="changeTime(keys,item.timeSlot1[i-1],(i-1),1)">
                                </div>
                              </div>
                          </div>
                          <hr>
                          <el-row>
                              <el-col :span="4">
                                <p class="txt-right">搜索加购</p>
                              </el-col>
                              <el-col :span="10">
                                  <el-form-item label="访客数">
                                      <input  class="likeInput" type="number" name=""  v-model="item.visitNum2" @input="changePer(item.visitNum2,keys,2)">
                                  </el-form-item>
                              </el-col>
                              <!-- <el-col :span="10">
                                  <el-form-item label="展现量">
                                      <input  class="likeInput" type="number" name=""  v-model="item.showNum2" @input="changeShow(item.showNum,keys)">
                                  </el-form-item>
                              </el-col> -->
                          </el-row>
                          <div class="tasktimeBox_fa">
                              <p class="tit">单日时间细分</p>
                              <div class="tasktimeBox_fa_dis">
                                <div class="tasktimeBox" v-for="i in 24" :key="i">
                                    <p class="bg">{{i-1}}</p>
                                    <input type="number" name="" min="0" v-model="item.timeSlot2[i-1]" @change="changeTime(keys,item.timeSlot2[i-1],(i-1),2)">
                                </div>
                              </div>
                          </div>
                          <!-- <div class="tasktimeBox_fa">
                              <p class="tit">单日时间细分</p>
                              <div class="tasktimeBox" v-for="i in 24" :key="i">
                                  <p class="bg">{{i-1}}点</p>
                                  <input type="number" name="" min="0" v-model="item.sumTime[i-1]">
                              </div>

                          </div> -->
                      </div>
                  </el-form-item>
                  <el-form-item label="自定义要求">
                      <div class="inputBox-left">
                          <el-row>
                              <el-col :span="12">
                                  <el-form-item label="游览滞留时间" label-width="102">
                                      <el-select v-model="formList.extUsedCoefficient" placeholder="请选择" @change="getResidence(formList.extUsedCoefficient)">
                                      <el-option v-for="(item,times) in waitmeList" :key="times" :label="item.dictLabel" :value="item.extValue"></el-option>
                                      </el-select>
                                  </el-form-item>
                              </el-col>
                              <el-col :span="12">
                                  <el-form-item label="浏览深度">
                                      <el-select v-model="formList.nuorenApiAddBean.gprs" placeholder="请选择" @change="getResidence2(formList.nuorenApiAddBean.gprs)">
                                      <el-option :label="item.dictLabel" :value="item.dictValue" v-for="(item,g4) in g4List" :key="g4"></el-option>
                                      </el-select>
                                  </el-form-item>
                              </el-col>
                            <el-col :span="12">
                              <el-form-item label="访客性别" style="margin-top: 15px">
                                <el-select v-model="formList.nuorenApiAddBean.sex" placeholder="请选择" @change="getSex(formList.nuorenApiAddBean.sex)">
                                  <el-option :label="item.dictLabel" :value="item.dictValue" v-for="(item,sex) in sexList" :key="sex"></el-option>
                                </el-select>
                              </el-form-item>
                            </el-col>
                              <!-- <el-col :span="12">
                                  <el-form-item label="访客筛选">
                                      <el-select v-model="formList.filter" placeholder="请选择" @change="getResidence2(formList.filter)">
                                      <el-option :label="item.dictLabel" :value="item.dictValue" v-for="(item,g4) in g4List" :key="g4"></el-option>
                                      </el-select>
                                  </el-form-item>
                              </el-col> -->
                          </el-row>

                      </div>
                  </el-form-item>
                  <el-form-item label="发布天数">
                      <input  class="likeInput mini" type="number" name="" @input="changeDay2(formList.numberDays)"  v-model="formList.numberDays" oninput="this.value=this.value.replace(/\D/g,'').replace(/^0+(?=\d)/,'')">
                      <span class="mr10">天</span>
                      <div class="in-block">
                          <span class="commButton" :class="dayStyle==days?'active':''" v-for="(item,days) in btlist" :key="days" @click="changeDay(item,days)" >{{item}}天</span></div>
                  </el-form-item>
                  <el-form-item>
                      <el-checkbox-group v-model="radioType">
                          <el-checkbox  label="浏览商品详情页"></el-checkbox>
                          <el-checkbox  label="货比三家"></el-checkbox>
                          <el-checkbox  label="浏览商品评价"></el-checkbox>
                          <el-checkbox  label="查看评价"></el-checkbox>
                      </el-checkbox-group>
                  </el-form-item>

                  <el-form-item label="开始时间">
                      <el-date-picker
                      v-model="formList.startDate"
                      type="date"
                      :editable="false"
                      placeholder="选择日期"
                      format="yyyy 年 MM 月 dd 日"
                      value-format="yyyy-MM-dd"
                      :picker-options="pickerOptions0"

                      >
                      </el-date-picker>
                  </el-form-item>
                  <el-form-item>
                      <div v-show="busType">
                          <!-- <el-button type="primary" @click="goRelease">点击发布</el-button> -->
                          <el-button class="btn-search mt20" type="primary" :loading="loading" @click="goRelease">
                              <span v-if="!loading">点击发布</span>
                              <span v-else>正在发布...</span>
                          </el-button>
                          <el-button @click="needReload">取消</el-button>
                      </div>
                      <div class="commTs" >
                          <p>
                              任务时长
                              <span> {{formList.numberDays}}</span>
                              天，
                              <br>
                              APP流量：共计发布 <span>{{taskCount}} </span>
                              个任务，共消耗条数为<span>{{taskNumber}}</span>
                              条
                              <br>
                              搜索收藏：共计发布 <span>{{taskCount1}} </span>
                              个任务，共消耗条数为<span>{{taskNumber1}}</span>
                              条
                              <br>
                              搜索加购：共计发布 <span>{{taskCount2}} </span>
                              个任务，共消耗条数为<span>{{taskNumber2}}</span>
                              条
                          </p>
                      </div>
                  </el-form-item>
              </el-form>
            </el-tab-pane>
            <el-tab-pane class="collection tab" label="收藏任务" name="tbCollection"></el-tab-pane>
            <el-tab-pane class="add tab" label="加购任务" name="tbAdd"></el-tab-pane>
            <el-tab-pane class="wangwang tab" label="旺旺打标" name="wangwang"></el-tab-pane>
            <el-tab-pane class="guangguang tab" label="逛逛点赞" name="guangguang"></el-tab-pane>
            <!-- <el-tab-pane class="tbLive tab" label="淘宝直播" name="tbLive"></el-tab-pane> -->
            <!-- <el-tab-pane class="dayGood tab" label="每日好店" name="tbDayGood"></el-tab-pane> -->
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import sidebarPage from '../../components/sidebar'

import $ from 'jquery'
import http from '../../axios'
import { getIdFromUrl } from '@/utils'
export default {
  inject: ['reload'],
  components: {
    sidebarPage
  },
  data () {
    return {
      // restaurants: [], // 历史数据
      loading: false, // 等待转圈
      radioType: ['浏览商品详情页'], // type值
      busType: true, // 显是区域
      activeName: 'tbTask', // title高亮
      type: 1,
      dayStyle: -1,
      extUsedCoefficient2: '0',
      sex: '0',
      taskCount: 100, // 总任务量
      taskNumber: 900, // 总任务条数
      taskCount1: 100, // 总任务量
      taskNumber1: 100, // 总任务条数
      taskCount2: 100, // 总任务量
      taskNumber2: 100, // 总任务条数
      tabnav1: [{
        name: 'APP流量',
        type: 1,
        link: '/tbTask'
      },
      // {
      //   name: 'PC流量',
      //   type: 2,
      //   link: '/tbPc'
      // },
      {
        name: '猜你喜欢',
        type: 3,
        link: '/tblike'
      },
      // {
      //   name: '淘口令',
      //   type: 4,
      //   link: '/tbpassw'
      // }
      ],
      keyForm: [{
        keyword: '',
        visitNum: 100,
        showNum: 800,
        visitNum1: 100,
        showNum1: 0,
        visitNum2: 100,
        showNum2: 0,
        timeSlot: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        sumTime: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        timeSlot1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        timeSlot2: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        click: 0
      }],
      waitmeList: [
        {
          dictLabel: '100-180秒(免费)',
          dictSort: 1,
          dictValue: '100-180',
          extValue: '0'
        },
        {
          dictLabel: '180-280秒(收费10%)',
          dictSort: 2,
          dictValue: '180-280',
          extValue: '0.1'
        },
        {
          dictLabel: '280-380秒(收费20%)',
          dictSort: 3,
          dictValue: '280-380',
          extValue: '0.2'
        }
      ], // 滞留时间
      g4List: [
        {
          dictLabel: '不浏览',
          dictSort: 1,
          dictValue: '0',
          extValue: '0'
        },
        {
          dictLabel: '随机浏览',
          dictSort: 2,
          dictValue: '1',
          extValue: '0.1'
        },
        {
          dictLabel: '深度浏览',
          dictSort: 3,
          dictValue: '2',
          extValue: '0.2'
        }
      ],
      //性别参数
      sexList: [
        {
          dictLabel: '随机',
          dictSort: 1,
          dictValue: '0',
          extValue: '0'
        },
        {
          dictLabel: '男',
          dictSort: 2,
          dictValue: '1',
          extValue: '0.5'
        },
        {
          dictLabel: '女',
          dictSort: 3,
          dictValue: '2',
          extValue: '0.5'
        }
      ],
      // 4g比例
      btlist: ['7', '15', '30'],
      Proportion: [0.03, 0.03, 0.03, 0.03, 0.03, 0.03, 0.03, 0.02, 0.02, 0.05, 0.05, 0.07, 0.05, 0.05, 0.05, 0.07, 0.05, 0.05, 0.05, 0.05, 0.07, 0.05, 0.02, 0.02],
      formList: {
        compareOther: 'N', // 货比三家
        lookDetail: 'N', // 浏览详情
        lookEvaluation: 'N', // 浏览评价
        platformType: '', // 平台类型
        flowType: '', // 流量类型
        goodsTitle: '', // 商品标题
        goodsUrl: '', // 商品链接
        startDate: '', // 开始时间
        showCount: 0, // 展现数量
        visitorCount: 0, // 访客数量
        numberDays: 1, // 发布天数
        extUsedCoefficient: '0', // 额外消耗总额
        nuorenApiAddBean: {// 其余参数
          gprs: '不浏览', // 4g比例
          residence_time: '100-180', // 停留时间
          sex: '0' // 性别
        },
        taskListSubs: [],
        filter: [
          {

          }
        ]
      },
      pickerOptions0: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      getGoodId: '',
      timeNum: 1
    }
  },
  created () {
    let _this = this
    // 获取当前小时
    let myDate = new Date()
    let hours = Number(myDate.getHours())
    // 获取点数分配
    // let allnum = 100
    let allnum = 100 // 访客量总和
    let sun = []
    let sunmu = 0
    for (let i = hours; i < 24; i++) {
      sun[i] = allnum * _this.Proportion[i]
      sunmu = sun[i] + sunmu
    }
    let aa = (allnum - sunmu) / (24 - hours)
    sunmu = 0
    for (let i = hours; i < 24; i++) {
      sun[i] = Math.floor(sun[i] + aa)
      sunmu = sun[i] + sunmu
    }
    let lastnum = allnum - sunmu
    if (lastnum < 0) {
      lastnum = Math.abs(lastnum)
      for (let i = 23; i >= hours; i--) {
        if (lastnum > 0) {
          if (sun[i] >= 1) {
            sun[i] = sun[i] - 1
            lastnum--
          }
        }
      }
    } else if (lastnum > 0) {
      sun.forEach((item, index) => {
        if (lastnum > 0) {
          sun[index] = item + 1
          lastnum--
        }
      })
    }
    for (let i = 0; i < 24; i++) {
      if (i < hours) {
        _this.$set(_this.keyForm[0].timeSlot, i, 0)
        // _this.$set(_this.keyForm[0].sumTime, i, 0)
        _this.$set(_this.keyForm[0].timeSlot1, i, 0)
        _this.$set(_this.keyForm[0].timeSlot2, i, 0)
      } else {
        _this.$set(_this.keyForm[0].timeSlot, i, sun[i])
        // _this.$set(_this.keyForm[0].sumTime, i, sun[i])
        _this.$set(_this.keyForm[0].timeSlot1, i, sun[i])
        _this.$set(_this.keyForm[0].timeSlot2, i, sun[i])
      }
    }
  },
  methods: {
    // 重置数据
    needReload () {
      this.reload()
    },
    // tab切换页面
    handleClick (tab, event) {
        this.$router.push({path: '/'+tab.name})
    },
    // 改变天数
    changeDay (day, id) {
      let _this = this
      _this.dayStyle = id
      _this.formList.numberDays = day
      _this.countAll()
    },
    tabChange (index, link) {
      this.type = index
      this.$router.push({path: link})
    },
    addkey (keys) { // 添加关键词
      let _this = this
      _this.keyForm.push({
        keyword: '',
        visitNum: 100,
        showNum: 800,
        visitNum1: 100,
        showNum1: 0,
        visitNum2: 100,
        showNum2: 0,
        click: '',
        timeSlot: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        sumTime: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        timeSlot1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        timeSlot2: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      })
      let keyFormVisitNum = {
        a: _this.keyForm[keys + 1].visitNum,
        b: _this.keyForm[keys + 1].visitNum1,
        c: _this.keyForm[keys + 1].visitNum2
      }
      _this.changePer(Number(keyFormVisitNum.a), keys + 1, 3)
    },
    delkey () { // 删除关键词
      let _this = this
      let num = _this.keyForm.length - 1
      if (num > 0) {
        _this.keyForm.splice(num, 1)
      } else {
        _this.$message({
          message: '关键词至少要有一个',
          type: 'warning'
        })
      }
      _this.countAll()
    },
    // 时间点数改变访客数也变化
    changeTime (num, val, index, curr) {
      let _this = this
      let res = /^[1-9]+[0-9]*]*$/
      if (!res.test(val)) {
        // _this.$message({
        //   type: 'warning',
        //   message: '请输入纯数字, 且数字必须大于或等于0'
        // })

        if (curr === 0) {
          _this.$set(_this.keyForm[num].timeSlot, index, 0)
        } else if (curr === 1) {
          _this.$set(_this.keyForm[num].timeSlot1, index, 0)
        } else {
          _this.$set(_this.keyForm[num].timeSlot2, index, 0)
        }
        _this.countAll()
      }
      if (val === '') {
        if (curr === 0) {
          _this.$set(_this.keyForm[num].timeSlot, index, 0)
        } else if (curr === 1) {
          _this.$set(_this.keyForm[num].timeSlot1, index, 0)
        } else {
          _this.$set(_this.keyForm[num].timeSlot2, index, 0)
        }
      }
      let sum = 0
      if (curr === 0) {
        _this.keyForm[num].timeSlot.forEach((item) => {
          sum += Number(item)
        })
      } else if (curr === 1) {
        _this.keyForm[num].timeSlot1.forEach((item) => {
          sum += Number(item)
        })
      } else {
        _this.keyForm[num].timeSlot2.forEach((item) => {
          sum += Number(item)
        })
      }
      if (curr === 0) {
        // 返回
        _this.keyForm[num].visitNum = sum
        // 设置展现量
        let zx = sum * 8
        _this.$set(_this.keyForm[num], 'showNum', zx)
      } else if (curr === 1) {
        _this.keyForm[num].visitNum1 = sum
        // 设置展现量
        _this.$set(_this.keyForm[num], 'visitNum1', sum)
      } else {
        _this.keyForm[num].visitNum2 = sum
        // 设置展现量
        _this.$set(_this.keyForm[num], 'visitNum2', sum)
      }
      _this.countAll()
    },
    changeShow (allcount, list) {
      let _this = this
      let res = /^[0-9]+[0-9]*]*$/
      if (!res.test(allcount)) {
        _this.$message({
          type: 'warning',
          message: '请输入大于或者等于0的纯数字！'
        })
        _this.$set(_this.keyForm[list],'showNum', '')
      }
      _this.countAll()
    },
    // 访客数改变时间点重新分配
    changePer (allcount, list, curr) {
      let _this = this
      let res = /^[0-9]+[0-9]*]*$/
      // let allcount = Number(v1) + Number(v2) + Number(v3)
      if (!res.test(allcount)) {
        _this.$message({
          type: 'warning',
          message: '请输入不能少于0的纯数字！'
        })
        if (curr === 1) {
          _this.$set(_this.keyForm[list], 'visitNum1', '')
        } else if (curr === 2) {
          _this.$set(_this.keyForm[list], 'visitNum2', '')
        } else {
          _this.$set(_this.keyForm[list], 'visitNum', '')
        }
        allcount = 0
      }

      // if (allcount === '' || Number(allcount) > 1000000 || allcount === '0') {
      //   _this.$message({
      //     type: 'warning',
      //     message: '每天访客数不能少于1或者大于100万'
      //   })
      //   if (curr === 1) {
      //     _this.$set(_this.keyForm[list], 'visitNum1', 1)
      //   } else if (curr === 2) {
      //     _this.$set(_this.keyForm[list], 'visitNum2', 1)
      //   } else {
      //     _this.$set(_this.keyForm[list], 'visitNum', 1)
      //   }
      //   allcount = 1
      // }
      let allcount1 = Number(_this.keyForm[list].visitNum) + Number(_this.keyForm[list].visitNum1) + Number(_this.keyForm[list].visitNum2)

      let myDate = new Date()
      let hours = Number(myDate.getHours())
      // 获取点数分配
      let allnum = Number(allcount)
      let allnum1 = Number(allcount1)
      let sun = []
      let sun1 = []
      let sunmu = 0
      let sunmu1 = 0
      for (let i = hours; i < 24; i++) {
        sun[i] = allnum * _this.Proportion[i]
        sun1[i] = allnum1 * _this.Proportion[i]
        sunmu = sun[i] + sunmu
        sunmu1 = sun1[i] + sunmu1
      }
      let aa = (allnum - sunmu) / (24 - hours)
      let aaa = (allnum1 - sunmu1) / (24 - hours)
      sunmu = 0
      sunmu1 = 0
      for (let i = hours; i < 24; i++) {
        sun[i] = Math.round(sun[i] + aa)
        sun1[i] = Math.round(sun1[i] + aaa)
        sunmu = sun[i] + sunmu
        sunmu1 = sun1[i] + sunmu1
      }
      let lastnum = allnum - sunmu
      let lastnum1 = allnum1 - sunmu1
      if (lastnum < 0) {
        lastnum = Math.abs(lastnum)
        for (let i = 23; i >= hours; i--) {
          if (lastnum > 0) {
            if (sun[i] >= 1) {
              sun[i] = sun[i] - 1
              lastnum--
            }
          }
        }
      } else if (lastnum > 0) {
        sun.forEach((item, index) => {
          if (lastnum > 0) {
            sun[index] = item + 1
            lastnum--
          }
        })
      }
      if (lastnum1 < 0) {
        lastnum1 = Math.abs(lastnum1)
        for (let i = 23; i >= hours; i--) {
          if (lastnum1 > 0) {
            if (sun1[i] >= 1) {
              sun1[i] = sun1[i] - 1
              lastnum1--
            }
          }
        }
      } else if (lastnum1 > 0) {
        sun1.forEach((item, index) => {
          if (lastnum1 > 0) {
            sun1[index] = item + 1
            lastnum1--
          }
        })
      }
      for (let i = 0; i < 24; i++) {
        if (i < hours) {
          if (curr === 1) {
            _this.$set(_this.keyForm[list].timeSlot1, i, 0)
          } else if (curr === 2) {
            _this.$set(_this.keyForm[list].timeSlot2, i, 0)
          } else if (curr === 0) {
            _this.$set(_this.keyForm[list].timeSlot, i, 0)
          }
          if (curr === 3) {
            _this.$set(_this.keyForm[list].timeSlot1, i, 0)
            _this.$set(_this.keyForm[list].timeSlot2, i, 0)
            _this.$set(_this.keyForm[list].timeSlot, i, 0)
          }
        } else {
          if (curr === 1) {
            _this.$set(_this.keyForm[list].timeSlot1, i, sun[i])
          } else if (curr === 2) {
            _this.$set(_this.keyForm[list].timeSlot2, i, sun[i])
          } else if (curr === 0) {
            _this.$set(_this.keyForm[list].timeSlot, i, sun[i])
          }
          if (curr === 3) {
            _this.$set(_this.keyForm[list].timeSlot1, i, sun[i])
            _this.$set(_this.keyForm[list].timeSlot2, i, sun[i])
            _this.$set(_this.keyForm[list].timeSlot, i, sun[i])
          }
        }
      }
      // 设置展现量
      let zx = Number(allcount) * 8
      if (zx === 0) {
        zx = 0
      }
      if (curr === 1) {
        _this.$set(_this.keyForm[list], 'showNum1', zx)
      } else if (curr === 2) {
        _this.$set(_this.keyForm[list], 'showNum2', zx)
      } else {
        _this.$set(_this.keyForm[list], 'showNum', zx)
      }
      _this.countAll()
    },
    // 更改发布天数
    changeDay2 (day) {
      let _this = this
      let days = Number(day)
      if (days === '' || days <= 0) {
        _this.$message({
          type: 'warning',
          message: '天数不能小于1'
        })
        _this.$set(_this.formList, 'numberDays', '')
      } else if (days === 7) {
        _this.dayStyle = 0
      } else if (days === 15) {
        _this.dayStyle = 1
      } else if (days === 30) {
        _this.dayStyle = 2
      } else {
        _this.dayStyle = -1
      }
      _this.countAll()
    },
    // key值不能为空
    getKey (val, keys) {
      let _this = this
      if (val === '') {
        _this.$message({
          type: 'warning',
          message: '请输入关键字'
        })
        return
      }

      // 判断关键字是否正确
      for (let index = 0; index < _this.keyForm.length; index++) {
        // if (_this.keyForm[keys].keyword === '') {
        //   _this.$message({
        //     type: 'warning',
        //     message: '关键词' + (keys + 1) + '不能为空'
        //   })
        //   return
        // }
        // if (_this.keyForm[keys].visitNum === '' || Number(_this.keyForm.visitNum) < 1) {
        //   _this.$message({
        //     type: 'warning',
        //     message: '关键词' + (keys + 1) + '的访客数必须大于1'
        //   })
        //   return
        // }
        // if (_this.keyForm[keys].showNum === '') {
        //   _this.$message({
        //     type: 'warning',
        //     message: '关键词' + (keys + 1) + '的展现量必须大于或者等于0'
        //   })
        //   return
        // }
        let arrkey = []
        let keywordNew = _this.keyForm[keys].keyword.replace(/\s+/g, '')
        arrkey = keywordNew.split('')// 字符串转数组
        let errorKeyWord = []
        arrkey.forEach((item2, index2) => {
          if (_this.formList.goodsTitle.indexOf(item2) === -1) {
            errorKeyWord.push(item2)
          }
        })
        console.log(keywordNew)
        if (errorKeyWord.length > 0) {

          _this.$message({
            type: 'error',
            message: "关键词'"+ (index + 1) +"'" + errorKeyWord + "'不存在标题中"
          })
          return

        }
      }
    },
    // 获取停留时间
    getResidence (vId) {
      let _this = this
      let obj = {}
      obj = this.waitmeList.find((item) => { // 这里的userList就是上面遍历的数据源
        return item.extValue === vId// 筛选出匹配数据
      })
      _this.formList.nuorenApiAddBean.residence_time = obj.dictValue
      _this.countAll()
    },
    // 获取额外消耗参数2
    getResidence2 (vId) {
      let _this = this
      let obj = {}
      obj = this.g4List.find((item) => { // 这里的userList就是上面遍历的数据源
        return item.dictValue === vId// 筛选出匹配数据
      })
      _this.extUsedCoefficient2 = obj.extValue
      _this.countAll()
    },
    // 改变性别
    getSex(vId) {
      let _this = this
      let obj = {}
      obj = this.sexList.find((item) => { // 这里的userList就是上面遍历的数据源
        return item.dictValue === vId// 筛选出匹配数据
      })
      _this.sex = obj.extValue
      _this.countAll()
    },
    // 计算总和
    countAll () {
      let _this = this
      // 计算任务
      let sumtas = 0
      let sumtas01 = 0
      let sumtas02 = 0
      _this.keyForm.forEach((item) => {
        let sumtask = item.visitNum
        let sumtask1 = item.visitNum1
        let sumtask2 = item.visitNum2
        sumtas += Number(sumtask)
        sumtas01 += Number(sumtask1)
        sumtas02 += Number(sumtask2)
      })
      _this.taskCount = sumtas * (Number(_this.formList.numberDays))
      _this.taskCount1 = sumtas01 * (Number(_this.formList.numberDays))
      _this.taskCount2 = sumtas02 * (Number(_this.formList.numberDays))
      // 计算消耗条数
      let sumtas2 = 0
      _this.keyForm.forEach((item) => {
        let sumtask2 = item.showNum
        sumtas2 += Number(sumtask2)
      })
      let tlTime = Number(_this.formList.extUsedCoefficient)
      let tlTime2 = Number(_this.extUsedCoefficient2)
      let sexTime = Number(_this.sex)

      let w1 = Math.round((sumtas * (1 + tlTime + tlTime2+sexTime)) + sumtas2)
      let w2 = Math.round((sumtas01 * (1 + tlTime + tlTime2)))
      let w3 = Math.round((sumtas02 * (1 + tlTime + tlTime2)))

      _this.taskNumber = w1 * (Number(_this.formList.numberDays))
      _this.taskNumber1 = w2 * (Number(_this.formList.numberDays))
      _this.taskNumber2 = w3 * (Number(_this.formList.numberDays))
    },
    // 发布任务
    goRelease () {
      let _this = this
      if (_this.formList.goodsUrl === '') {
        _this.$message({
          type: 'warning',
          message: '请输入宝贝链接'
        })
        // eslint-disable-next-line no-useless-return
        return
      } else if (_this.formList.goodsUrl.indexOf('http') === -1) {
        _this.$message({
          type: 'warning',
          message: '请输入正确的宝贝链接'
        })
        // eslint-disable-next-line no-useless-return
        return
      } else if (_this.formList.goodsTitle === '') {
        _this.$message({
          type: 'warning',
          message: '宝贝标题不能为空'
        })
      } else {
        // 判断关键字是否正确
        for (let index = 0; index < _this.keyForm.length; index++) {
          if (_this.keyForm[index].keyword === '') {
            _this.$message({
              type: 'warning',
              message: '关键词' + (index + 1) + '不能为空'
            })
            return
          }
          // if (_this.keyForm[index].visitNum === '' || Number(_this.keyForm[index].visitNum) < 1) {
          //   _this.$message({
          //     type: 'warning',
          //     message: '关键词' + (index + 1) + '的访客数必须大于1'
          //   })
          //   return
          // }
          // if (_this.keyForm[index].showNum === '') {
          //   _this.$message({
          //     type: 'warning',
          //     message: '关键词' + (index + 1) + '的展现量必须大于或者等于0'
          //   })
          //   return
          // }
          let arrkey = []
          let keywordNew = _this.keyForm[index].keyword.replace(/\s+/g, '')
          arrkey = keywordNew.split('')// 字符串转数组
          let errorKeyWord = []
          arrkey.forEach((item2, index2) => {
            if (_this.formList.goodsTitle.indexOf(item2) === -1) {
              errorKeyWord.push(item2)
            }
          })
          if (errorKeyWord.length > 0) {
            _this.$message({
              type: 'error',
              message: "关键词'"+ (index + 1) +"'" + errorKeyWord + "'不存在标题中"
            })
            return
          } else if ((index === _this.keyForm.length - 1 && _this.keyForm[index].keyword !== '' && _this.keyForm[0].keyword !== '')) {
            _this.goRelease2()
          }
        }
      }
    },
    goRelease2 () {
      let _this = this
      if (!localStorage.getItem('info')) {
        this.$message({
          type: 'warning',
          message: '请登录后使用'
        })
        this.$router.push({path: '/login'})
      }
      for (var i = 0; i < _this.keyForm.length; i++) {
        if (_this.keyForm[i].showNum === '' && _this.keyForm[i].showNum1 === '' && _this.keyForm[i].showNum2 === '' &&
          _this.keyForm[i].visitNum === '' && _this.keyForm[i].visitNum1 === '' && _this.keyForm[i].visitNum2 === '') {
          _this.$message({
            type: 'warning',
            message: '访客数不能为空，展现量不能为空'
          })
          return
        }
        if (_this.keyForm[i].showNum === '' || _this.keyForm[i].visitNum === '') {
          _this.keyForm[i].showNum = 0
          _this.keyForm[i].visitNum = 0

        }
        if (_this.keyForm[i].visitNum1 === '') {
          _this.keyForm[i].showNum1 = 0
          _this.keyForm[i].visitNum1 = 0
        }
        if (_this.keyForm[i].visitNum2 === '') {
          _this.keyForm[i].showNum2 = 0
          _this.keyForm[i].visitNum2 = 0
        }
        if (_this.keyForm[i].visitNum2 === 0 && _this.keyForm[i].visitNum1 === 0 && _this.keyForm[i].visitNum === 0) {
          _this.$message({
            type: 'warning',
            message: '访客数不能为空'
          })
          return
        }
      }
      if (_this.formList.numberDays === '' || _this.formList.numberDays <= 0) {
        _this.$message({
          type: 'warning',
          message: '天数不能小于1'
        })
        _this.$set(_this.formList, 'numberDays', 1)
      }
      _this.loading = true
      // 深拷贝一组keyForm
      let arr = _this.keyForm.map(o => ({...o}))
      arr.forEach((item, index) => {
        let sumtask2 = item.timeSlot
        let sumtask03 = item.timeSlot1
        let sumtask04 = item.timeSlot2
        let sumtask05 = item.sumTime
        item.timeSlot = sumtask2.join(',')
        item.sumTime = sumtask05.join(',')
        item.timeSlot1 = sumtask03.join(',')
        item.timeSlot2 = sumtask04.join(',')
        item.click = _this.formList.numberDays * (Number(_this.keyForm[index].visitNum) + Number(_this.keyForm[index].showNum) + Number(_this.keyForm[index].visitNum1) + Number(_this.keyForm[index].showNum1) + Number(_this.keyForm[index].visitNum2) + Number(_this.keyForm[index].showNum2))
        item.myClick = _this.formList.numberDays * (Number(_this.keyForm[index].visitNum) + Number(_this.keyForm[index].visitNum1) + Number(_this.keyForm[index].visitNum2))
        item.collectVisit = item.visitNum1
        item.collectShow = item.showNum1
        item.collectTimeSlot = item.timeSlot1

        item.cartVisit = item.visitNum2
        item.cartShow = item.showNum2
        item.cartTimeSlot = item.timeSlot2
        delete item.visitNum1
        delete item.showNum1
        delete item.timeSlot1
        delete item.visitNum2
        delete item.showNum2
        delete item.timeSlot2
      })
      _this.formList.taskListSubs = arr
      let arr2 = JSON.parse(JSON.stringify(_this.formList))
      // let obj4g = {}

      // obj4g = _this.g4List.find((item) => { // 这里的userList就是上面遍历的数据源
      //   return item.dictValue === _this.formList.nuorenApiAddBean.gprs// 筛选出匹配数据
      // })
      // _this.extUsedCoefficient2 = obj4g.extValue
      // arr2.extUsedCoefficient = (Number(_this.formList.extUsedCoefficient) + Number(_this.extUsedCoefficient2)).toFixed(1)
      // 货比三家
      _this.radioType.forEach((item) => {
        if (item === '浏览商品详情页') {
          _this.$set(arr2, 'lookDetail', 'Y')
        } else if (item === '货比三家') {
          _this.$set(arr2, 'compareOther', 'Y')
        } else if (item === '浏览商品评价') {
          _this.$set(arr2, 'lookEvaluation', 'Y')
        }
      })
      // var clickRationClick
      // if (_this.formList.nuorenApiAddBean.gprs === '30%(免费)') {
      //   clickRationClick = 30
      // } else if (_this.formList.nuorenApiAddBean.gprs === '1') {
      //   clickRationClick = 50
      // } else if (_this.formList.nuorenApiAddBean.gprs === '2') {
      //   clickRationClick = 80
      // } else if (_this.formList.nuorenApiAddBean.gprs === '3') {
      //   clickRationClick = 100
      // }
      // if (_this.formList.nuorenApiAddBean.gprs === '30%(免费)') {
      //   arr2.nuorenApiAddBean.gprs = 0
      // }
      if (_this.formList.nuorenApiAddBean.gprs === '不浏览') {
        _this.formList.nuorenApiAddBean.gprs = '0'
      }
      let dataTime = new Date()
      let dataTimeFull = dataTime.getFullYear() + '-' + (dataTime.getMonth() + 1) + '-' + dataTime.getDate()
      let newTime = dataTimeFull.replace(/[-]/g,"")
      let oldTime = _this.formList.startDate.replace(/[-]/g,"")
      if (parseInt(oldTime) < parseInt(newTime)) {
        _this.formList.startDate = dataTimeFull
      }
      const params = {
        clickRation: this.formList.nuorenApiAddBean.gprs,
        endTime: _this.formList.startDate,
        // gprs: Number(arr2.nuorenApiAddBean.gprs), // gprs网络的手机比例，参数值：0、1、2、3 分别代表30%，50%，80%，100% ,
        hoverTime: arr2.nuorenApiAddBean.residence_time, // 停留时间 参数值：120|180、180|280、280|380、380|480 ,
        keyList: _this.formList.taskListSubs,
        module: 2,
        sex: this.formList.nuorenApiAddBean.sex,
        money: _this.taskNumber,
        platform: 1,
        remark: '',
        rwzl: _this.formList.numberDays,
        sexType: 0,
        startTime: _this.formList.startDate, // 任务开始时间
        taskTotal: _this.taskCount, // 发布任务总量 任务总量必须等于 每天任务量*任务的执行天数 ,
        title: _this.formList.goodsTitle,
        tmallRation: 0,
        url: _this.formList.goodsUrl
      }
      try {
        http.publishTaobao(params).then(({ data }) => {
          _this.loading = false
          switch (data.code) {
            case 0:
              // if (data.res !== '') {
              //   if (JSON.parse(data.res).code === 200) {
              //     _this.$message({
              //       message: '发布成功',
              //       type: 'success'
              //     })
              //   } else {
              //     _this.$message({
              //       message: JSON.parse(data.res).message,
              //       type: 'error'
              //     })
              //   }
              // } else {
              //   _this.$message({
              //     message: '发布任务失败',
              //     type: 'error'
              //   })
              // }
              this.$alert(data.res, '发布任务提示', {
                confirmButtonText: '确定',
                callback: action => {

                  _this.reload()
                }
              });

              break
            case 401:
              _this.$message.error('账号过期，请重新登录')
              _this.$router.push({path: '/login'})
              break
            default:
              _this.$message.error(data.msg)
              break
          }
        })
      } catch (error) {
        _this.$message.error(error)
      }
    },
    // 淘口令解析
    pawInfoTao (url) {
      // var getGoodId = ''
      let params = {
        pwd: url
      }
      try {
        http.pwdInfo(params).then(({ data }) => {
          if (data.code === 0) {
            this.getGoodId = data.data.id
            this.ajaxTB(data.data.id)
          } else {
            this.$message.error(data.msg)
          }
        })
      } catch (error) {
        this.$message.error(error)
      }
    },
    changeLink () {
      let _this = this
      var badyLinkID
      this.formList.goodsTitle = ''
      if (!localStorage.getItem('token')) {
        _this.$router.push({path: '/login'})
        return
      }
      // this.pawInfoTao(this.formList.goodsUrl)
      if (this.formList.goodsUrl.startsWith('http') && this.formList.goodsUrl.indexOf('id=') !== -1) {
        badyLinkID = getIdFromUrl(this.formList.goodsUrl)
      } else {
        this.$message.info('请输入正确的宝贝链接或ID')
        this.loading = false
        return
      }
      _this.ajaxTB(badyLinkID)

    },
    ajaxTB (badyLinkID) {
      let _this = this
      let params = {
        url: this.formList.goodsUrl
      }
      try {
        http.newGetgoodsTitle(params).then(({ data }) => {
          _this.loading = false
          switch (data.code) {
            case 0:
              _this.formList.goodsTitle = data.data.data.title
              break
            case 401:
              _this.$message.error('账号过期，请重新登录')
              _this.$router.push({path: '/login'})
              break
            default:
              _this.$message.error(data.msg)
              break
          }
        })
      } catch (error) {
        _this.$message.error(error)
      }
    }
  },
  mounted () {
    // 设置默认消耗参数
    let _this = this
    _this.formList.platformType = _this.$route.meta.title
    _this.formList.flowType = _this.$route.meta.title2
    let myDate = new Date()
    let myDateFull = myDate.getFullYear() + '-' + (myDate.getMonth() + 1) + '-' + myDate.getDate()
    _this.formList.startDate = myDateFull
    _this.timeNum = myDate.getHours()
    if (_this.$route.params.busininfo !== undefined) {
      let info = JSON.parse(_this.$route.params.busininfo)
      info.keyList.forEach((item, index) => {
        item.timeSlot = item.timeSlot.split(',')
        item.sumTime = item.sumTime.split(',')
        item.timeSlot1 = item.collectTimeSlot.split(',')
        item.timeSlot2 = item.cartTimeSlot.split(',')
        item.visitNum1 = item.collectVisit
        item.visitNum2 = item.cartVisit
        item.showNum1 = 0
        item.showNum2 = 0
        delete item.collectVisit
        delete item.collectTimeSlot
        delete item.cartTimeSlot
        delete item.cartVisit
      })
      _this.keyForm = info.keyList
      _this.formList.goodsUrl = info.url
      _this.formList.goodsTitle = info.title
      _this.taskCount = info.taskTotal
      _this.taskNumber = info.money
      _this.formList.startDate = info.startTime
      _this.countAll()
    }
  }
}
</script>
<style lang="less" scoped>
.btn_li {
    float: left;
    display: block;
    line-height: 1;
    white-space: nowrap;
    background: #fff;
    border: 1px solid #dcdfe6;
    font-weight: 500;
    border-left: 0;
    color: #606266;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0;
    cursor: pointer;
    -webkit-transition: all .3s cubic-bezier(.645,.045,.355,1);
    transition: all .3s cubic-bezier(.645,.045,.355,1);
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 0;
}
.container {
    background:rgba(255,255,255,1);
    border:1px solid rgba(238,238,238,1);
    border-radius:5px;
    width: 1200px;
    margin: auto;
    margin-top: 15px;
    margin-bottom: 15px;
    .main-left {
        width: 15%;
    }
    .main-right {
        width: 85%;
        padding: 15px 56px 27px;
        box-sizing: border-box;
        /deep/ .el-tabs__item {
            width: 103px !important;
            padding: 0;
            text-align: center;
            font-size: 18px;
            color: #333333;
        }
        /deep/ .el-tabs__item.is-active,
        /deep/ .el-tabs__item:hover {
            color: #FC6B0E;
        }
        /deep/ .el-tabs__active-bar {
            background: #FC6B0E;
        }
        .commonTabnav {
            ul {
                font-size: 0;
                border-left: 1px solid #dcdfe6;
                border-radius: 3px;
                overflow: hidden;
                li {
                    .btn_li();
                }
                li:first-child {
                    border-radius: 3px 0 0 3px;
                }
                li:last-child {
                    border-radius: 0 3px 3px 0;
                }
                .active {
                    background-color: #fc6b0e;
                    border-color: #fc6b0e;
                    color: #fff;
                }
            }
        }
        /deep/ .el-form-item__content {
            margin-left: 102px !important;
        }
        .taotask_time {
            border: 2px solid #fc6b0e;
            background-color: #fef0e7;
            margin: 15px 0;
            padding: 10px;
            position: relative;
            .taotaskAdd, .taotaskReduce{
                position: absolute;
                width: 40px;
                height: 40px;
                left: -50px;
                text-align: center;
                line-height: 38px;
                font-size: 23px;
                border: 1px solid #fc6b0e;
                border-radius: 50%;
                cursor: pointer;
            }
            .taotaskAdd {
                background-color: #fc6b0e;
                color: #fff;
                top: 0;
            }
            .taotaskReduce {
                top: 50px;
                color: #fc6b0e;
            }
            .likeInput {
                -webkit-appearance: none;
                background-color: #fff;
                background-image: none;
                border-radius: 4px;
                border: 1px solid #d4d4d4;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                color: #606266;
                font-size: inherit;
                height: 40px;
                line-height: 40px;
                outline: 0;
                padding: 0 15px;
                -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
                transition: border-color .2s cubic-bezier(.645,.045,.355,1);
                width: 100%;
            }
            /deep/ .el-form-item {
                margin-bottom: 5px;
            }
            .taoQs {
                text-align: right;
                line-height: 20px;
                font-size: 12px;
                color: #999;
                .taoQs_box {
                    position: relative;
                    display: inline-block;
                    margin-left: 10px;
                    .taoQs_boxText {
                        position: absolute;
                        right: 0;
                        background: #fff;
                        min-width: 150px;
                        width: 250px;
                        border-radius: 4px;
                        border: 1px solid #ebeef5;
                        padding: 12px;
                        z-index: 2000;
                        color: #606266;
                        line-height: 1.4;
                        text-align: justify;
                        font-size: 14px;
                        -webkit-box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
                        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
                        word-break: break-all;
                        top: 100%;
                        display: none;
                        h5 {
                            font-size: 15px;
                            margin-bottom: 12px;
                        }
                        p {
                            font-size: 13px;
                            line-height: 23px;
                        }
                    }
                    .taoQs_span{
                        display: block;
                        border-bottom: 1px solid #ffc49e;
                        cursor: pointer;
                        &:hover{
                            color:#fc6b0e;
                        }
                    }
                    &:hover .taoQs_boxText{
                        display: block;
                    }
                }
            }
            .dialogTbaoText{
                line-height: 24px;
            }
            .tasktimeBox input::-webkit-outer-spin-button,.tasktimeBox input::-webkit-inner-spin-button{
                -webkit-appearance: none !important;
                margin: 0;
            }
            .el-date-editor .el-input__suffix{
                display: none;
            }
            body .el-checkbox__input.is-checked+.el-checkbox__label {
                color: #fc6b0e;
            }
            .tasktimeBox_fa {
                .tit {
                    color: #666;
                    font-size: 12px;
                    height: 20px;
                    line-height: 20px;
                }
                .tasktimeBox_fa_dis {
                  display: flex;
                  justify-content: space-between;
                }
                .tasktimeBox {
                    display: inline-block;
                    margin-right: 2px;
                    border-radius: 10px;
                    overflow: hidden;
                    text-align: center;
                    // width: 18px;
                    border: 1px solid #fc6b0e;
                    p {
                        line-height: 22px;
                    }
                    .bg {
                        background-color: #fc6b0e;
                        color: #fff;
                    }
                    input {
                        margin: 0;
                        width: 100%;
                        border: 0;
                        background-color: transparent;
                        text-align: center;
                        display: block;
                        line-height: 24px;
                        color: #fc6b0e;
                    }

                }
            }

        }
        .likeInput {
            -webkit-appearance: none;
            background-color: #fff;
            background-image: none;
            border-radius: 4px;
            border: 1px solid #d4d4d4;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            color: #606266;
            font-size: inherit;
            height: 40px;
            line-height: 40px;
            outline: 0;
            padding: 0 15px;
            -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
            transition: border-color .2s cubic-bezier(.645,.045,.355,1);
            width: 100%;
        }
        .mini {
            width: 200px;
            display: inline-block;
        }
        .in-block {
          float: right;
          .commButton {
            display: inline-block;
            text-align: center;
            border-radius: 3px;
            min-width: 76px;
            height: 35px;
            padding: 0 15px;
            line-height: 35px;
            color: #fc6b0e;
            border: 1px solid #fc6b0e;
            margin-left: 10px;
            cursor: pointer;
          }
          .active {
            background-color: #fc6b0e;
            color: #fff;
          }
        }
        /deep/ .el-checkbox__label {
            color: #fc6b0e;
        }
        /deep/ .is-checked{
            /deep/ .el-checkbox__inner {
                border-color: #fc6b0e;
                background: #fc6b0e;
            }

        }
        /deep/ .el-button:focus {
            color: #fc6b0e;
            border-color: #f9d7c1;
            background-color: #fff6f1;
        }
        /deep/ .el-button:hover {
            color: #fc6b0e;
            border-color: #f9d7c1;
            background-color: #fff6f1;
        }
        /deep/ .el-button--primary {
            background-color: #fc6b0e;
            border-color: #fc6b0e;
        }
        /deep/ .el-button--primary:hover{
            background-color: #fd863a;
            border-color: #fd863a;
            color: #fff;
        }
        .commTs {
            font-size: 12px;
            color: #666;
            span {
                color: #ff1e00;
                font-size: 14px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/tbTask/tbTask.vue